import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionWhitelistEffects } from './competition-whitelist.effects'
import * as fromCompetitionWhitelist from './competition-whitelist.reducer'
import { CompetitionWhitelistSerializer } from './competition-whitelist.serializer'
import { CompetitionWhitelistService } from './competition-whitelist.service'
import { WhiteListCardComponent } from './whitelist-card/whitelist-card.component'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionWhitelist.FEATURE_NAME,
      fromCompetitionWhitelist.competitionWhitelistReducer
    ),
    EffectsModule.forFeature([CompetitionWhitelistEffects])
  ],
  providers: [
    CompetitionWhitelistService,
    {
      provide: CompetitionWhitelistSerializer,
      useClass: CompetitionWhitelistSerializer
    }
  ],
  declarations: [WhiteListCardComponent],
  exports: [WhiteListCardComponent]
})
export class CompetitionWhitelistModule {}
